<div class="card container">
  <h1 class="page-title">
    <span class="icon"><i class="fas fa-pallet"></i></span>{{ 'ShippingStatus.Header' | translate }}</h1>
  <p-timeline class="hidden md:block" [value]="events" align="top" layout="horizontal" styleClass="customized-timeline">
		<ng-template pTemplate="marker" let-event>
			<span class="custom-marker p-shadow-2" [style.backgroundColor]="event.color">
        <i [ngClass]="event.icon"></i>
      </span>
		</ng-template>
		<ng-template pTemplate="content" let-event>
			<p-card header="{{ event.status | translate }}" subheader="{{ event.progress }}">
        <div class="container">
          <div class="p-fluid grid">
            <div class="field col-12 mb-0">
              <label class="font-bold">{{ 'ShippingStatus.Event.Estimate' | translate }}: </label>
            </div>
            <div class="field col-12 mb-0">
              {{event.estimatedDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
            </div>
            <div class="field col-12 mb-0">
              <label class="font-bold">{{ 'ShippingStatus.Event.Actual' | translate }}: </label>
            </div>
            <div class="field col-12 mb-0">
              {{event.realDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
            </div>

            <div class="field col-12" style="height: 2em;">

              <button *ngIf="event.gpsLinkFlag == true  && event.stage == 3" (click)="openNewPageWithGPS()" pButton label="GPS Link" class="p-button-text"></button>

              <button *ngIf="event.stage == 4 && event.tmsUrl != null && event.tmsUrl != ''" (click)="gotoForwarderPage($event, event.tmsUrl)" pButton label="{{ 'ShippingStatus.Event.CheckDeliveryStatus' | translate }}" class="p-button-text"></button>
            </div>
          </div>
        </div>
			</p-card>
		</ng-template>
	</p-timeline>

  <p-timeline class="block md:hidden" [value]="events" align="alternate" styleClass="customized-timeline">
		<ng-template pTemplate="marker" let-event>
			<span class="custom-marker p-shadow-2" [style.backgroundColor]="event.color">
                <i [ngClass]="event.icon"></i>
            </span>
		</ng-template>
		<ng-template pTemplate="content" let-event>
			<p-card header="{{ event.status | translate }}" subheader="{{ event.progress }}">
        <div class="container">
          <div class="p-fluid grid">
            <div class="field col-12 mb-0">
              <label class="font-bold">{{ 'ShippingStatus.Event.Estimate' | translate }}: </label>
            </div>
            <div class="field col-12 mb-0">
              {{event.estimatedDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
            </div>
            <div class="field col-12 mb-0">
              <label class="font-bold">{{ 'ShippingStatus.Event.Actual' | translate }}: </label>
            </div>
            <div class="field col-12 mb-0">
              {{event.realDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
            </div>
          </div>

        </div>

        <button *ngIf="event.gpsLinkFlag == true  && event.stage == 3" (click)="openNewPageWithGPS()" pButton label="GPS Link" class="p-button-text"></button>

				<button *ngIf="event.stage == 4 && event.tmsUrl != null && event.tmsUrl != ''" (click)="gotoForwarderPage($event, event.tmsUrl)" pButton label="{{ 'ShippingStatus.Event.CheckDeliveryStatus' | translate }}" class="p-button-text"></button>
			</p-card>
		</ng-template>
	</p-timeline>

  <div class="mt-2">
    <p-table #dataTable class="datatable hidden md:block" [value]="moveOrders" [columns]="selectedColumns" [resizableColumns]="true" [reorderableColumns]="true" columnResizeMode="expand" rowExpandMode="single" dataKey="pdNo" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
        [autoLayout]="true" sortMode="multiple">
        <ng-template pTemplate="caption">
          <laas-table-column-toggle
            [optionsColumn]="tableColumns"
            [dataTable]="dataTable">
          </laas-table-column-toggle>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th style="width: 5%;"></th>
                <th [pSortableColumn]="col.field" *ngFor="let col of tableColumns" pResizableColumn pReorderableColumn>
                  {{ col.header | translate }}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
            <tr>
                <td>
                    <span [pRowToggler]="rowData" (click)="rowToggleBtnClick($event, rowData, expanded)" style="cursor: pointer;"><i
            [class]="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i></span>
                </td>
                <td *ngFor="let col of columns">
                    <ng-container [ngSwitch]="col.field">
                        <ng-container *ngSwitchCase="'moStatus'">
                          <div class="overflow-text">
                            {{ rowData[col.field] | optionsMapping:MOStatusOptions }}
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'cartonCnt'" >
                          <div class="overflow-text">
                            {{ rowData[col.field]
                              | number: "1.0-0"
                              | replaceNullWith: "-"
                            }}
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'priority'">
                          <div class="overflow-text">
                            {{ rowData[col.field] | optionsMapping:priorityOptions | replaceNullWith:'-' }}
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <div class="overflow-text">
                            {{rowData[col.field]}}
                          </div>
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData>
            <tr>
                <td [attr.colspan]="columns.length + 1">
                    <p>{{ 'ShippingStatus.DetailTable.MODetail' | translate }} - {{ rowData.pdNo }}</p>
                    <div>
                        <p-table #detailDataTable class="datatable" [value]="rowData.moveOrderItems" [columns]="detailColumns" [resizableColumns]="true" [reorderableColumns]="true" columnResizeMode="expand" [scrollable]="true" [rows]="10" scrollHeight="15rem" [virtualScroll]="true">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let col of columns" pResizableColumn pReorderableColumn>
                                      {{ col.header | translate }}
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="detailCols">
                                <tr>
                                    <td *ngFor="let col of detailColumns">
                                        <ng-container [ngSwitch]="col.field">
                                            <ng-container *ngSwitchDefault>
                                              <div class="overflow-text">
                                                {{rowData[col.field]}}
                                              </div>
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td [attr.colspan]="detailColumns.length" style="text-align: center;">
                                        {{ 'Common.Table.NoData' | translate }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="selectedColumns.length + 1" style="text-align: center;">
                    {{ 'Common.Table.NoData' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>

    <laas-data-view class="block md:hidden" [value]="moveOrders" [paginator]="true" [lazy]="true" [showDataViewLayoutOptions]="false">
      <ng-template let-result pTemplate="listItem">
        <div class="field col-12">
          <div class="p-fluid grid laas-list-item">
            <ng-container *ngFor="let col of columns" [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'moveOrderItems'">
                <div class="field col-12 md:col-6 lg:col-4 mb-0 text-center">
                  <span (click)="toggleBtnClick($event, result.moveOrderItems)" style="cursor: pointer;"><i
                    [class]="'fas fa-chevron-down'"></i></span>
                  <laas-data-view *ngIf="result.moveOrderItems?.expanded" [value]="result.moveOrderItems" [paginator]="false" [lazy]="true" [showHeader]="false" [showFooter]="false">
                    <ng-template let-result pTemplate="listItem">
                      <div class="field col-12">
                        <div class="p-fluid grid laas-list-item laas-detail-list-item">
                          <div class="field col-12">
                            <p>{{ 'ShippingStatus.DetailTable.MODetail' | translate }} - {{ result.pdNo }}</p>
                          </div>
                          <ng-container *ngFor="let col of detailColumns" [ngSwitch]="col.field">
                            <ng-container *ngSwitchDefault>
                              <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-3 lg:col-2 mb-0 text-right">
                                <label class="font-bold mb-0">{{ col.header | translate }}</label>
                              </div>
                              <div class="field col-8 md:col-3 lg:col-2 mb-0" [ngSwitch]="col.dataType">
                                <ng-container *ngSwitchCase="'date'">
                                  <div class="overflow-text">
                                    {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                  </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                  <div class="overflow-text">
                                    {{ result[col.field] | replaceNullWith:'-'}}
                                  </div>
                                </ng-container>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </div>

                    </ng-template>
                  </laas-data-view>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'moStatus'">
                <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-3 lg:col-2 mb-0 text-right">
                  <label class="font-bold mb-0">{{ col.header | translate }}</label>
                </div>
                <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                  {{ result[col.field] | optionsMapping:MOStatusOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-3 lg:col-2 mb-0 text-right">
                  <label class="font-bold mb-0">{{ col.header | translate }}</label>
                </div>
                <div class="field col-8 md:col-3 lg:col-2 mb-0" [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ result[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </laas-data-view>
  </div>
</div>
